export default function Links() {

    return (

        <div className="m-3">

            <p>

                GitHub:&nbsp;
                <a href='https://github.com/guilhermeasn/mask-hooks' className="text-info" target='_blank' rel="noopener noreferrer">
                    https://github.com/guilhermeasn/mask-hooks
                </a>

                <br />

                NPM:&nbsp;
                <a href='https://www.npmjs.com/package/mask-hooks' className="text-info" target='_blank' rel="noopener noreferrer">
                    https://www.npmjs.com/package/mask-hooks
                </a>

                <br />

                Sandbox:&nbsp;
                <a href='https://codesandbox.io/p/sandbox/amazing-sea-2m3m8j' className="text-info" target='_blank' rel="noopener noreferrer">
                    https://codesandbox.io/p/sandbox/amazing-sea-2m3m8j
                </a>

            </p>
            
        </div>
    
    );

}